import React from 'react';
import { WhiteContainer } from '../../../../certificates-constancies/type1/info/components';
import ReusableButton from '@/presentation/reusables/Button';
import StepsToFollow from '@/presentation/modules/procedures/components/StepsToFollow';
import { ListUL } from './LateralPDF';

interface Props {
  steps?: any;
  inRegister?: boolean;
  setShowModel: (value: boolean) => void;
}

const InfoComponent = (props: Props) => {
  const { steps, inRegister, setShowModel } = props;

  return (
    <div data-testid="cmp-GraduatedCertificated">
      <WhiteContainer>
        <b>Requisitos necesarios</b>
        <ListUL>
          <li>Haber completado el 100% de tu plan de estudios.</li>
          <li>No debes tener deudas.</li>
        </ListUL>
        {!inRegister && (
          <ReusableButton
            iconAppend="arrow-right"
            outlined
            style={{ marginTop: '16px' }}
            text="Ver modelo"
            onClick={() => setShowModel(true)}
          />
        )}
      </WhiteContainer>
      <WhiteContainer>
        <b>Consideraciones</b>
        <p>
          Si eres egresado en más de una carrera y necesitas la constancia de
          una carrera anterior, registra una{' '}
          <a
            style={{
              color: '#5B36F2',
              textDecorationLine: 'underline'
            }}
            href="https://portal.utp.edu.pe/tramites/ticketera/registro?v=TA0047"
            target="_blank"
            rel="noreferrer"
          >
            solicitud de SAE.
          </a>
        </p>
      </WhiteContainer>
      <WhiteContainer>
        <StepsToFollow steps={steps} />
      </WhiteContainer>
    </div>
  );
};

export default InfoComponent;
